import { Empty } from "antd"
import Title from "antd/es/typography/Title"
import { styled } from "styled-components"

export const FutureDevelopmentPlaceholder = () => {
  return (
    <PageContainer>
      <STitle level={3}>
      Feature Under Development
      </STitle>

      <SDescription>  
      We’re working hard to enhance your experience! This section is currently in development as we refine and test its functionality to ensure it meets our standards.
      </SDescription>

      <SEmpty description="" />

      <STitle level={4}>
        Thank you for your patience!
      </STitle>

      <SDescription>
      Stay tuned — we’ll announce updates as soon as it’s ready.
      </SDescription>
    </PageContainer>
  )
}

const SEmpty = styled(Empty)`
  margin-top: 24px;

  .ant-empty-image {
    width: 100%;
    height: 100%;
  }
`

const SDescription = styled.p`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.65);
  max-width: 560px;
  text-align: center;
`

const STitle = styled(Title)`
  font-size: 24px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
`

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`